import { CButton, CCol, CForm, CFormGroup, CInput, CInputGroup, CInputGroupAppend, CInputGroupText, CLabel, CRow, CSelect } from '@coreui/react'
import React, { useState } from 'react'
import { isValidEmail, Limpiar } from './Tools'
import { Icon } from '@iconify/react'
import { CustomSelect } from 'src/security/OTP'
import { RegisterCustomSelect } from './RegisterCustomSelect'
import AxiosManager from 'src/config/axiosManager'
import validateDate from 'src/reusable/validateDate'
import { RegisterStepLeft } from './RegisterStepLeft'

export const RegisterStep1 = ({ DataForm, setDataForm, handleChange, tipodocumento, onCancel, onSuccess }) => {
    const [consultando, setConsultando] = useState(false)
    const [ErrorRNC, setError] = useState(false)
    const consultaRNC = async () => {
        if (parseInt(DataForm.pais) === 1) {
            setConsultando(true)
            AxiosManager.get("/rnc", { params: { q: DataForm.rnc } })
                .then(({ data }) => {
                    setDataForm({
                        ...DataForm,
                        rncvalid: data.rnc !== '',
                        rnc: data.rnc,
                        nombre: data.nombre,
                        nombrecomercial: data.nombre
                    });
                    setError(data.rnc === '')
                })
                .catch(() => {
                    setDataForm({
                        ...DataForm,
                        rncvalid: false,
                    })
                    setError(true)
                }
                )
                .finally(() => {
                    setConsultando(false);
                    setTimeout(() => setError(false), 10000)
                }
                )
        } else {

            setDataForm({
                ...DataForm,
                rncvalid: Limpiar(DataForm.rnc).length > 4,
            });

        }

    };


    const valid = parseInt(DataForm.estado) === 2 ||
        (parseInt(DataForm.estado) === 1 && DataForm.rncvalid === true && validateDate(DataForm.constitucion))

    return (
        <CRow>
            <RegisterStepLeft DataForm={DataForm} />
            <CCol xs="12" md="5">
                <div className="text-md-left ">
                    <h3 className="text-primary">
                        Informacion de la Cooperativa.
                    </h3>
                    <p>
                        Agradecemos completar la información solicitada de forma clara, precisa y verídica. Este formulario está dividido en dos secciones: Información de la Cooperativa e Información del Representante. Todos los campos marcados con asterisco (*) son obligatorios.
                    </p>
                    <p></p>
                </div>

                <div className="form-group " style={{ marginTop: 30 }}>

                    {[
                        {
                            id: 1,
                            name: `La Cooperativa se encuentra constituida y cuenta con ${tipodocumento?.label}`
                        },
                        {
                            id: 2,
                            name: 'Estamos en proceso de Constitucion.'
                        }
                    ].map((row, index) => {
                        return (
                            <RegisterCustomSelect
                                key={index}
                                id={row.id}
                                name="estado"
                                value={DataForm.estado}
                                label={row.name}
                                onChange={handleChange}


                            />
                        )
                    })}
                </div>

                {DataForm.estado === 1 && <CRow>
                    <CCol xs="5">
                        <CLabel htmlFor="company"> {tipodocumento?.label} :</CLabel>
                        <CInput
                            name="rnc"
                            value={DataForm.rnc}
                            onChange={handleChange}
                            onBlur={consultaRNC}
                            className={`mb-3 ${consultando ? "opaco cargando" : ""}`}
                            style={
                                DataForm.rncvalid
                                    ? {}
                                    : { borderColor: "red" }
                            }
                        />
                    </CCol>
                    <CCol xs="5">
                        <CLabel htmlFor="company">  Fecha de constitucion :</CLabel>
                        <CInput
                            value={DataForm.constitucion}
                            placeholder="constitucion"
                            onChange={handleChange}
                            type='date'
                            name="constitucion"
                            className={`mb-3 ${consultando ? "opaco cargando" : ""}`}
                            style={
                                validateDate(DataForm.constitucion)
                                    ? {}
                                    : { borderColor: "red" }
                            }
                        />
                    </CCol>
                    <CFormGroup row>

                        <CCol xs="12" md="12" style={{ textAlign: 'start' }}>
                            <div className="form-group">
                                <ul className="password-indicator">
                                    {ErrorRNC && DataForm.rnc.trim().length !== 0 && <li>
                                        R.N.C. No es valido.
                                    </li>
                                    }

                                </ul>
                            </div>
                        </CCol>
                    </CFormGroup>
                </CRow>
                }

                <div
                    className="row justify-content-center"
                    style={{ flexFlow: "row", paddingTop: DataForm.estado === 1 ? 230 : 300 }}
                >
                    <CButton
                        type="submit"
                        style={{ background: 'red', height: 60, padding: 0, margin: 0 }}
                        className="btn-block LoginInput2"
                        onClick={onCancel}
                    >
                        Cancelar
                    </CButton>
                    <CButton
                        type="submit"
                        color="primary"
                        style={{ height: 60, padding: 0, margin: 0 }}
                        className="btn-block LoginInput2"
                        disabled={!valid}
                        onClick={onSuccess}
                    >
                        Siguiente
                    </CButton>
                </div>
            </CCol>
        </CRow>
    )
}
